module.exports = __webpack_public_path__ + "img/375_stations_arrow.c229933a.svg";